import {combineEpics} from 'web-app/util/redux-observable';

import conversationEpics from './conversation/epics';
import typedConversationEpics from './conversation/typed-epics';
import newMessageEpics from './new-conversation/epics';
import conversationCenterEpics from './conversation-center/epics';
import inboxSearchEpics from './search-box/epics';
import messageComposerEpics from './inbox-message-composer/epics';
import typedMessageComposerEpics from './inbox-message-composer/typed-epics';
import newInboxConversationEpics from './new-inbox-conversation/epics';

export default combineEpics(
    conversationEpics,
    typedConversationEpics,
    newMessageEpics,
    conversationCenterEpics,
    inboxSearchEpics,
    messageComposerEpics,
    typedMessageComposerEpics,
    newInboxConversationEpics,
);
